import { FaArrowCircleRight } from 'react-icons/fa';
import Button from '../Button';

interface MainContentProps {
  onLogin: () => void;
}

const MainContent = ({ onLogin }: MainContentProps) => (
  <div className="py-8 mx-auto text-center sm:py-0 sm:ml-16 md:text-start">
    <p className="mb-6 text-lg font-bold">WELCOME TO</p>
    <h1 className="mb-8 text-4xl font-bold md:text-5xl">
      APILOGY ADMIN-PORTAL
    </h1>
    <p className="mx-4 mb-10 text-lg font-thin text-black opacity-75 sm:mx-0">
      Admin Portal is a portal that can be accessed by administrators to access
      and manage information related to Apilogy users, such as developer and
      publisher data.
    </p>
    <Button type="button" iconRight={<FaArrowCircleRight />} onClick={onLogin}>
      Get Started
    </Button>
  </div>
);

export default MainContent;
